module.exports = __webpack_public_path__ + "img/1437348771.e89803c9.jpg";